import React from 'react'
import PropTypes from 'prop-types'
import LayoutNoLogin from './NoLogin'
import styled from 'styled-components'

function Layout({ page, title, text, textStyles, noMenu, noLink, titleStyles }) {
  return (
    <LayoutNoLogin
      page={page}
      title={title}
      text={text}
      noMenu={noMenu}
      noLink={noLink}
      textStyles={textStyles}
      titleStyles={titleStyles}
    />
  )
}

Layout.propTypes = {
  page: PropTypes.node,
  title: PropTypes.string,
  text: PropTypes.string,
  noMenu: PropTypes.bool,
  noLink: PropTypes.bool,
  textStyles: PropTypes.instanceOf(styled.style),
  titleStyles: PropTypes.object,
}

export default Layout

/*
import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { GlobalHeader } from '../../../shard'
import { Color, Border } from '../../../../const'
import SideMenu from './SideMenu'
import PageTitle from './PageTitle'
import { SP_WIDTH } from 'config/constants'

function Layout({ page, title, text, noMenu, noLink }) {
  let sideMenu = (
    <SideMenuWrapper>
      <SideMenu />
    </SideMenuWrapper>
  )

  if (noMenu) {
    sideMenu = ''
  }

  return (
    <Wrapper>
      <GlobalHeaderWrapper>
        <GlobalHeader noLink={noLink} />
      </GlobalHeaderWrapper>
      {sideMenu}
      <PageWrapper noMenu={noMenu}>
        {title && <PageTitle title={title} text={text} />}
        {page}
      </PageWrapper>
      <Footer>
        <CopyWrite>© TANAKA-Chain Optical Company</CopyWrite>
      </Footer>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr ${SP_WIDTH}px 1fr;
  grid-template-rows: 76px 1fr 39px;
  width: 100%;
`

const GlobalHeaderWrapper = styled.div`
  grid-column: 2;
  grid-row: 1;
  padding: 10px 0 0 0;
  background: ${Color.BACKGROUND.BASE};
  border-bottom: ${Border.BASE};
`

const PageWrapper = styled.div`
  ${(props) => css`
    grid-column: ${props.noMenu ? '1 / 3' : '2'};
    grid-row: 2;
    padding: 60px 30px 100px 0;
    padding: ${props.noMenu ? '60px 30px 100px' : '60px 30px 100px 0'};
  `}
`

const SideMenuWrapper = styled.div`
  grid-column: 1;
  grid-row: 2;
  padding: 60px 0 0 40px;
`

const Footer = styled.div`
  grid-column: 1 / 3;
  grid-row: 3;
  border-top: ${Border.BASE};
  padding: 7px 20px;
  background: ${Color.BASE};
`

const CopyWrite = styled.div`
  height: 24px;
  font-size: 13px;
  line-height: 1.85;
  color: #979797;
`

Layout.propTypes = {
  page: PropTypes.node,
  title: PropTypes.string,
  text: PropTypes.string,
  noMenu: PropTypes.bool,
  noLink: PropTypes.bool,
}

export default Layout
*/
